import { MutationTree } from "vuex";
import { ServicesRestoreData, ServicesState } from "../types/ServicesState";
import { servicesKey, commonCssKey } from "@service/helpers/sessionHelper";
import Vue from 'vue';
import { addStylesToHead, removeStylesFromDOM } from "@service/helpers/domHelper";
import { STYLES_FROM_CONFIG_NAME } from "@common/constants";

export const mutations: MutationTree<ServicesState> = {
    setServiceParams(state, data) {
        if (data.service.name && data.service.params) {
            Vue.set(state.services, data.service.name, data.service.params);
        }
        localStorage.setItem(servicesKey(data.backend), JSON.stringify({
            services: state.services,
            updateTime: state.updateTime
        }));
    },
    clearServiceParams(state, data) {
        localStorage.removeItem(servicesKey(data.backend));
        state.services = {};
    },
    restore(state, data: ServicesRestoreData) {
        state.services = data.services;
        state.updateTime = data.updateTime;

        data.commonCss && addStylesToHead(data.commonCss, "styles-from-config");
    },
    setUpdateTime(state, data) {
        state.updateTime = data;
    },
    setFreshChat(state, instance) {
        state.freshChat = instance;
    },
    setCommonCss(_, data) {
        if(data.css) {
            localStorage.setItem(commonCssKey(data.backend), data.css);
        }
        else {
            localStorage.setItem(commonCssKey(data.backend), "");
            removeStylesFromDOM(STYLES_FROM_CONFIG_NAME);
        }
    },
    /* удаляет параметры сервиса по переданному названию */
    removeServiceParams(state, name) {
        delete state.services[name];
    }
}
